import { render, staticRenderFns } from "./PopupConfirm.vue?vue&type=template&id=bfb3d332&scoped=true&"
import script from "./PopupConfirm.vue?vue&type=script&lang=js&"
export * from "./PopupConfirm.vue?vue&type=script&lang=js&"
import style0 from "./PopupConfirm.vue?vue&type=style&index=0&id=bfb3d332&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb3d332",
  null
  
)

export default component.exports